import { useSelectedSystem } from 'projectSections/designPanels/hooks/useSelectedSystem'
import { useTranslate } from 'ra-core'
import { useCallback, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { useStudioSignalsLazy } from 'Studio/signals/useStudioSignalsLazy'
import { validateActionRequirements } from '../utils/validateActionRequirements'

export interface ActionRequirementsValidation {
  isValid: boolean
  message: string
  projectId?: number
}

export const useActionRequirements = (action: any): ActionRequirementsValidation => {
  const location = useLocation()
  const selectedSystem = useSelectedSystem()
  const translate = useTranslate()

  const getValidation = useCallback(() => {
    const actionType = action?.action || ''
    const validation = validateActionRequirements(actionType, location.pathname, selectedSystem)

    if (!validation.isValid && validation.message) {
      return {
        ...validation,
        message: translate(validation.message),
      }
    }

    return validation
  }, [action, location.pathname, selectedSystem, translate])

  const [validationState, setValidationState] = useState<ActionRequirementsValidation>(getValidation)

  useEffect(() => {
    setValidationState(getValidation())
  }, [getValidation])

  const handleStudioSignal = useCallback(() => {
    setValidationState(getValidation())
  }, [getValidation])

  useStudioSignalsLazy(
    handleStudioSignal,
    ['objectAdded', 'objectRemoved', 'objectChanged', 'objectSelected'],
    undefined,
    { trackHandler: true }
  )

  return validationState
}
